import i18n from '@/i18n/i18n';
console.log(i18n);

// const i18n = new VueI18n({
//   locale: localStorage.lang || 'zh', //初始未选择默认 zh 中文
//   messages,
//   silentTranslationWarn: true
// });

const p2TableId = 2;
const p3TableId = 3;
const redLineBomTableId = 88;
const redLineManufacturerTableId = 80;
const redLineAttachmentTableId = 201;

export default
  {
    // input_width,//input宽度
    // input_width_small,//input中等宽度
    // right_lists_0,
    // right_lists_1,//cls
    // right_lists_1_2,//subcls
    // right_lists_2,//变更
    // right_lists_3,//bom
    // right_lists_4,//i18n.t('message.list.manufacturer')
    // right_lists_5,//i18n.t('message.list.attachment')
    // right_lists_6,//i18n.t('message.list.whereUsed')
    // right_lists_7,//关联对象
    // right_lists_8,//历史记录
    // right_lists_9,//变更对象
    // right_lists_10,//用户首选项
    // right_lists_11,//用户用户组
    // right_lists_12,//用户组用户
    // right_lists_13,//i18n.t('message.list.manufacturer')/部件使用位置
    // right_lists_14,//..历史记录
    // right_lists_15,//..历史记录
    // right_lists_16,//..历史记录
    // right_lists_17,//..历史记录
    // right_lists_18,//..历史记录
    // right_lists_19,//..i18n.t('message.list.whereUsed')
    p2TableId,
    p3TableId,
    redLineBomTableId,//redline Bom table id
    redLineManufacturerTableId,//redline Bom table id
    redLineAttachmentTableId,
  }
